import {
  LayoutDashboard,
  Calendar,
  TabletSmartphone,
  Globe,
  Wrench,
  FolderOpen,
} from 'lucide-react';

import { AppCategory } from '@optidev/shared-types';

export interface CategoryConfig {
  value: AppCategory;
  label: string;
  icon: React.ElementType;
}

/**
 * Single source of truth for app categories.
 * Used by both the App Library page (filter pills, detail modal)
 * and the Submit App Modal (category selection).
 */
export const APP_CATEGORIES: CategoryConfig[] = [
  { value: AppCategory.DASHBOARDS, label: 'Dashboard', icon: LayoutDashboard },
  { value: AppCategory.PRODUCTIVITY, label: 'Productivity', icon: Calendar },
  { value: AppCategory.KIOSK, label: 'Kiosk', icon: TabletSmartphone },
  { value: AppCategory.WEBSITE, label: 'Website', icon: Globe },
  { value: AppCategory.INTERNAL_TOOL, label: 'Internal Tool', icon: Wrench },
  { value: AppCategory.OTHER, label: 'Other', icon: FolderOpen },
];

/** Map from category value to its config for quick lookups */
export const CATEGORY_MAP = Object.fromEntries(
  APP_CATEGORIES.map((c) => [c.value, c])
) as Record<string, CategoryConfig>;

/** Get label for a category value, with fallback */
export function getCategoryLabel(category: string): string {
  return CATEGORY_MAP[category]?.label || category.charAt(0).toUpperCase() + category.slice(1);
}

/** Get icon for a category value, with fallback */
export function getCategoryIcon(category: string): React.ElementType {
  return CATEGORY_MAP[category]?.icon || FolderOpen;
}
